import pathToRegexp from "path-to-regexp";
import { NavLinkProps } from "react-router-dom";

const regexp = pathToRegexp([
  "/*-volunteering",
  "/volunteering*",
  "/*-volunteering/in-*",
]);

export const isOpportunityTabActive: NavLinkProps["isActive"] = (
  match,
  location
) => {
  // The opportunities tab should be active on the homepage
  if (location.pathname === "/") {
    return true;
  }

  // Ensure that volunteering organisations don't match the /volunteering* route
  if (location.pathname.includes("/volunteering-organisations")) {
    return false;
  }

  return !!regexp.exec(location.pathname);
};
